import React, { FC } from 'react'
import { Button, IconButton, IconButtonProps, Tooltip } from '@mui/material'
import ViewListIcon from '@mui/icons-material/ViewList'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { mapGlobalModalContext, TModalReason } from '../api-context'

export const BtnFormCreate: FC<{ children: React.ReactNode }> = (props) => {
  return mapGlobalModalContext((context) => (
    <Tooltip title='Create new'>
      <Button
        size='small'
        onClick={() => context.show({ renderContent: () => props.children })}
        startIcon={<AddCircleOutlineIcon fontSize='small' />}
        sx={{ fontWeight: 600 }}
        variant='contained'
      >
        Create
      </Button>
    </Tooltip>
  ))
}

export interface IBtnFormDetailProps {
  formDetail: React.ReactNode
  onOpenModal?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onCloseModal?: (reason?: TModalReason) => void
}

export const BtnFormDetail: FC<IBtnFormDetailProps> = (props) => {
  return mapGlobalModalContext((context) => (
    <Tooltip title='Detail'>
      <IconButton
        onClick={(e) => {
          props.onOpenModal?.(e)
          context.show({ backdropActivated: true, renderContent: () => props.formDetail, onClose: props.onCloseModal })
        }}
      >
        <ViewListIcon />
      </IconButton>
    </Tooltip>
  ))
}

export interface IBtnDetailProps {
  onClick?: IconButtonProps['onClick']
}

export const BtnDetail: FC<IBtnDetailProps> = (props) => (
  <Tooltip title='Detail'>
    <IconButton onClick={props.onClick}>
      <ViewListIcon />
    </IconButton>
  </Tooltip>
)
